// src/ids/content-ids/content-ids.ts
import { State } from "@youversion/analytics-core";
var ContentIds = {
  App: (params) => {
    var _a, _b;
    return { primaryContentId: (_b = params.applicationId) != null ? _b : (_a = window.yvaDatastore) == null ? void 0 : _a.config.applicationId };
  },
  AudioBible: (params) => ({ primaryContentId: params.audioBibleVersionId.toString() }),
  AudioBibleReference: (params) => ({
    primaryContentId: params.usfm,
    secondaryContentId: params.audioBibleVersionId.toString()
  }),
  Auth: (params) => {
    var _a;
    return {
      primaryContentId: params.authType,
      secondaryContentId: (_a = params.userId) == null ? void 0 : _a.toString()
    };
  },
  Bible: (params) => ({
    primaryContentId: params.bibleVersionId.toString()
  }),
  BibleReference: (params) => ({
    primaryContentId: params.usfm,
    secondaryContentId: params.bibleVersionId.toString()
  }),
  CommentaryAnnotation: (params) => ({
    primaryContentId: params.annotationId.toString()
  }),
  CommentaryKeyword: (params) => ({
    primaryContentId: params.keywordId.toString()
  }),
  ContentPlaylist: (params) => ({
    primaryContentId: params.playlistId.toString(),
    secondaryContentId: params.playlistType
  }),
  ContentPlaylistItem: (params) => ({
    primaryContentId: params.playlistId.toString(),
    secondaryContentId: params.playlistType,
    tertiaryContentId: params.externalId.toString(),
    // eslint-disable-next-line sort-keys
    quaternaryContentId: params.index.toString()
  }),
  Friendship: () => ({}),
  Gift: (params) => ({
    primaryContentId: params.fund,
    secondaryContentId: params.frequency,
    tertiaryContentId: params.currency,
    // eslint-disable-next-line sort-keys
    quaternaryContentId: params.paymentMethod
  }),
  Guide: (params) => {
    var _a;
    return {
      primaryContentId: params.readingPlanId.toString(),
      secondaryContentId: params.languageTag,
      tertiaryContentId: (_a = params.subscriptionId) == null ? void 0 : _a.toString()
    };
  },
  GuideDay: (params) => {
    var _a;
    return {
      primaryContentId: params.readingPlanId.toString(),
      secondaryContentId: params.languageTag,
      tertiaryContentId: params.readingPlanDay.toString(),
      // eslint-disable-next-line sort-keys
      quaternaryContentId: (_a = params.subscriptionId) == null ? void 0 : _a.toString()
    };
  },
  GuidedPrayer: (params) => ({
    primaryContentId: params.guideId.toString(),
    secondaryContentId: params.dayId.toString()
  }),
  GuidedPrayerBackgroundAudio: (params) => ({
    primaryContentId: params.guideId.toString(),
    secondaryContentId: params.dayId.toString(),
    tertiaryContentId: params.audioCategoryId.toString()
  }),
  GuidedPrayerModule: (params) => ({
    primaryContentId: params.dayId.toString(),
    secondaryContentId: params.moduleId.toString(),
    tertiaryContentId: params.type,
    // eslint-disable-next-line sort-keys
    quaternaryContentId: params.index.toString()
  }),
  LocalVerseImage: (params) => ({
    primaryContentId: params.imageId,
    secondaryContentId: params.usfm,
    tertiaryContentId: params.languageTag,
    // eslint-disable-next-line sort-keys
    quaternaryContentId: params.bibleVersionId.toString()
  }),
  Moment: (params) => ({
    primaryContentId: params.momentId.toString()
  }),
  None: () => ({}),
  NonIdleSegment: () => ({}),
  Organization: (params) => ({
    primaryContentId: params.organizationId,
    secondaryContentId: params.languageTag
  }),
  Page: () => {
    var _a;
    return {
      primaryContentId: (_a = State.get("templatedPathname")) != null ? _a : location.pathname
    };
  },
  Plan: (params) => {
    var _a;
    return {
      primaryContentId: params.readingPlanId.toString(),
      secondaryContentId: params.languageTag,
      tertiaryContentId: (_a = params.subscriptionId) == null ? void 0 : _a.toString()
    };
  },
  PlanDay: (params) => {
    var _a;
    return {
      primaryContentId: params.readingPlanId.toString(),
      secondaryContentId: params.languageTag,
      tertiaryContentId: params.readingPlanDay.toString(),
      // eslint-disable-next-line sort-keys
      quaternaryContentId: (_a = params.subscriptionId) == null ? void 0 : _a.toString()
    };
  },
  PlanDevotionalAudio: (params) => {
    var _a;
    return {
      primaryContentId: params.readingPlanId.toString(),
      secondaryContentId: params.languageTag,
      tertiaryContentId: params.readingPlanDay.toString(),
      // eslint-disable-next-line sort-keys
      quaternaryContentId: (_a = params.subscriptionId) == null ? void 0 : _a.toString()
    };
  },
  Prayer: (params) => ({
    primaryContentId: params.prayerId.toString()
  }),
  RelatedContentBibleReference: (params) => ({
    primaryContentId: params.usfm,
    secondaryContentId: params.bibleVersionId.toString(),
    tertiaryContentId: params.referenceLevel
  }),
  Search: (params) => ({
    primaryContentId: params.searchQuery
  }),
  Story: (params) => ({
    primaryContentId: params.lessonId.toString()
  }),
  StoryActivity: (params) => ({
    primaryContentId: params.storyId,
    secondaryContentId: params.activityType
  }),
  StoryModule: (params) => ({
    primaryContentId: params.lessonId.toString(),
    secondaryContentId: params.moduleId.toString()
  }),
  StoryQuestion: (params) => ({
    primaryContentId: params.questionId,
    secondaryContentId: params.storyId
  }),
  StoryQuestionAnswer: (params) => ({
    primaryContentId: params.answerId,
    secondaryContentId: params.questionId,
    tertiaryContentId: params.storyId
  }),
  StoryScene: (params) => ({
    primaryContentId: params.sceneIndex.toString(),
    secondaryContentId: params.storyId
  }),
  User: (params) => ({
    primaryContentId: params.userId.toString()
  }),
  VerseImage: (params) => ({
    primaryContentId: params.imageId.toString(),
    secondaryContentId: params.usfm,
    tertiaryContentId: params.languageTag,
    // eslint-disable-next-line sort-keys
    quaternaryContentId: params.bibleVersionId.toString()
  }),
  VerseMemorization: (params) => ({
    primaryContentId: params.usfm,
    secondaryContentId: params.bibleVersionId.toString()
  }),
  Video: (params) => ({
    primaryContentId: params.videoId.toString(),
    secondaryContentId: params.languageTag
  }),
  VideoCollection: (params) => ({
    primaryContentId: params.videoCollectionId.toString(),
    secondaryContentId: params.languageTag
  }),
  VOTD: (params) => ({
    primaryContentId: params.date,
    secondaryContentId: params.usfm,
    tertiaryContentId: params.bibleVersionId.toString()
  })
};

export {
  ContentIds
};
